export default __webpack_public_path__ + "static/media/permission-viewer.205c1494.svg";